module.exports = __webpack_public_path__ + "img/bornutti26.556a617d.jpg";